define('view/controller/error/ErrorView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * Error page view
     *
     * @class ErrorView
     */
    return LayoutView.extend({

        template: '#error_page',

        ui: {
            reloadBtn: '.reload-page'
        },

        // Was href="javascript:window.history.back()" in the template -- a javascript: URI
        // navigation, which CSP's script-src gates the same as inline <script> execution but
        // with no nonce mechanism to allow it (CY1SDEV1-3837 dropped 'unsafe-inline').
        events: {
            'click @ui.reloadBtn': 'onReloadClick'
        },

        onReloadClick: function (e) {
            e.preventDefault();
            window.history.back();
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.additional_message = this.getOption('additionalMessage');
            result.type = this.getOption('type');

            return result;
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'error',
                'error_type': this.getOption('type')
            });
        }

    });

});
